import styled from 'styled-components';
import Typography from '../../../components/styles/Typography';
import { StyledLoginInnerLayoutProps } from './types';

export const StyledLoginInnerLayoutWrapper = styled.div<StyledLoginInnerLayoutProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: ${({ isBig }) => (isBig ? 'flex-start' : 'center')};
  padding: ${({ isBig }) => (isBig ? '4rem 2rem 0' : '4rem 2rem')};
  max-width: ${({ isBig }) => (isBig ? '56rem' : '36rem')};
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const StyledLoginInnerLayoutBox = styled.div<StyledLoginInnerLayoutProps>`
  position: relative;
  width: 100%;
  max-width: ${({ isBig }) => (isBig ? '44rem' : '28rem')};
  padding: ${({ isBig }) => (isBig ? '5rem 5rem 3.5rem' : '3rem 3rem')};
  border-radius: ${({ isBig }) => (isBig ? 'var(--r-xl) var(--r-xl) 0 0' : 'var(--r-xl)')};
  background-color: var(--surface);
  box-shadow: 0 24px 56px -12px rgba(9, 15, 56, 0.4),
    0 4px 12px -4px rgba(9, 15, 56, 0.16);
  min-height: ${({ isBig }) => (isBig ? 'calc(100vh - 4rem)' : '24rem')};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 1.5rem;
    right: 1.5rem;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--brand-green),
      var(--brand-lime),
      var(--brand-ink)
    );
    border-radius: 0 0 3px 3px;
  }
`;

export const StyledLoginInnerLayoutLogo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 2.25rem;

  svg {
    height: 4rem !important;
    width: auto !important;
    font-size: 4rem !important;
  }
`;

export const StyledLoginInnerLayoutHeadingWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const StyledLoginInnerLayoutHeading = styled(Typography).attrs({
  forwardedAs: 'h2',
  variant: 'h1',
})`
  color: var(--ink);
  font-weight: var(--weight-bold);
  font-size: var(--t-2xl);
  letter-spacing: var(--tracking-tight);
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const StyledLoginInnerLayoutSubtitle = styled(Typography).attrs({
  forwardedAs: 'span',
  variant: 'caption',
})`
  display: block;
  color: var(--muted);
  text-align: center;
  margin-bottom: 1.75rem;
`;

export const StyledLoginInnerLayoutDescription = styled(Typography).attrs({
  forwardedAs: 'p',
  variant: 'body',
})`
  color: var(--muted);
  margin-top: 0.75rem;
  margin-bottom: 2rem;
  text-align: center;
`;

export const StyledLoginInnerLayoutDecor = styled.div`
  display: none;
`;
